import { FC, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { PagesPaths } from '@/enums';
import { Link } from 'react-router-dom';
import styles from './ResetPasswordMessage.module.scss';

type ResetPasswordMessageProps = {
  userEmail: string;
  restartProcess: () => void;
};

const ResetPasswordMessage: FC<ResetPasswordMessageProps> = ({
  userEmail,
  restartProcess,
}) => {
  const { t } = useTranslation('forgotPassword');

  const [messageNotReceived, setMessageNotReceived] = useState(false);

  const toggleMessageNotReceived = () =>
    setMessageNotReceived(!messageNotReceived);

  return (
    <div className={styles.resetPasswordMessage}>
      <FontAwesomeIcon icon={faEnvelope} />
      <p>{t('emailSent')}</p>
      <button
        className={styles.linkButton}
        type="button"
        onClick={toggleMessageNotReceived}
      >
        {t('messageNotReceived')}
      </button>
      {messageNotReceived && (
        <>
          <p>{t('tryFollowing')}</p>
          <ul>
            <li>{t('checkSpamFolder')}</li>
            <li>{t('resendConfirmationEmail')}</li>
            <li>
              {t('isEmailCorrect1')}
              {userEmail}&nbsp;
              {t('isEmailCorrect2')}
              <button
                className={styles.linkButton}
                onClick={restartProcess}
                type="button"
              >
                {t('restartProcess')}
              </button>
            </li>
            <li>
              {t('stillHavingProblems')}&nbsp;
              <Link to={PagesPaths.Contact}>
                <b>{t('contactUs')}</b>
              </Link>
            </li>
          </ul>
        </>
      )}
    </div>
  );
};

export default ResetPasswordMessage;
